var MEMO_TYPE_COLORS = {
    Postcard: 'rgba(79,177,166,0.8)',
    Note: 'rgba(254,211,60,0.8)',
    Flag: 'rgba(249,163,44,0.8)',
    Alert: 'rgba(241,73,33,0.8)'
};
var MemoTypeGraph = /** @class */ (function () {
    function MemoTypeGraph() {
        this.typeLabels = [];
        this.barOptions = {
            scaleShowVerticalLines: false,
            responsive: true,
            tooltips: { enabled: false },
            scales: {
                xAxes: [
                    {
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false
                        },
                        stacked: false,
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ]
            }
        };
        this.barColors = [
            {
                backgroundColor: [
                    'rgba(79,177,166,0.8)',
                    'rgba(254,211,60,0.8)',
                    'rgba(249,163,44,0.8)',
                    'rgba(241,73,33,0.8)'
                ]
            }
        ];
    }
    Object.defineProperty(MemoTypeGraph.prototype, "data", {
        set: function (newData) {
            if (!newData) {
                return;
            }
            this.typeLabels = newData.map(function (item) { return item.name; });
            this.typeData = newData.map(function (item) { return item.score; });
            this.barColors = [
                {
                    backgroundColor: this.typeLabels.map(function (label) { return MEMO_TYPE_COLORS[label]; })
                }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return MemoTypeGraph;
}());
export { MemoTypeGraph };
